import React, { useCallback } from 'react';

import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import FilterIcon from '@material-ui/icons/FilterList';

import '../kits/kits.scss';

const UsageFiltersList = (props) => {
  const {
    onClick,
    hideClosed,
    surgeons = [],
    hospitals = [],
    surgeonsList = [],
    hospitalsList = [],
    onDelete,
  } = props;

  const getSurgeonName = useCallback((surgeonId) => {
    const surgeon = surgeonsList.find((surgeon) => surgeon.id === surgeonId);
    return surgeon ? `${surgeon.title} ${surgeon.firstName} ${surgeon.lastName}` : '';
  }, [surgeonsList]);

  const getHospitalName = useCallback((hospitalId) => {
    const hospital = hospitalsList.find((hospital) => hospital.id === hospitalId);
    return hospital ? hospital.name : '';
  }, [hospitalsList]);

  return (
    <div className='kit-filters-list__container'>
      <IconButton onClick={onClick}>
        <FilterIcon />
      </IconButton>

      {hideClosed && (
        <Chip label='Hide All Closed' onDelete={() => onDelete('closed')} />
      )}

      {/*{hideReturned && activeTab === 1 && (*/}
      {/*  <div className='kit-filters-list__item'>*/}
      {/*    Hide All Returned*/}
      {/*  </div>*/}
      {/*)}*/}

      {!!surgeons?.length && (
        surgeons.map((surgeon) => (
          <Chip label={getSurgeonName(surgeon)} onDelete={() => onDelete('surgeon', surgeon)} />
        ))
      )}

      {!!hospitals?.length && (
        hospitals.map((hospital) => (
          <Chip label={getHospitalName(hospital)} onDelete={() => onDelete('hospital', hospital)} />
        ))
      )}
    </div>
  );
};

export default UsageFiltersList;
